const styles = {
  card: {
    borderRadius: 4,
    p: 3,

    flexDirection: "column",
    justifyContent: "space-between",
  },
};

export default styles;
